<template>
  <v-row dense class="bgs">
    <!-- Attachment Type -->
    <v-col cols="12" class="d-flex align-center mb-4">
      <div class="label tit">
        Attachment Type <span class="required">*</span>
      </div>

      <v-btn @click="opd = true" class="lead-form-btn mr-3" variant="outlined">
        <span class="font-weight-regular">Create Lead form</span>
      </v-btn>

      <!-- Lead Forms Dropdown -->
      <LeadsSearch ref="leadsSearchRef" />
    </v-col>

    <!-- Call To Action -->
    <v-col cols="12" class="d-flex align-center mb-4">
      <div class="label tit">
        Call to action <span class="required">*</span>
      </div>
      <v-select
        v-model="store.ad_call_to_action_type"
        :items="ctaOptions"
        item-title="label"
        item-value="value"
        placeholder="Select call to action"
        variant="outlined"
        density="comfortable"
        hide-details
        class="flat-select"
        :class="{ 'has-error': submitted && !store.ad_call_to_action_type }"
      />
    </v-col>

    <!-- Website URL -->
    <v-col cols="12" class="d-flex align-center mb-4">
      <div class="label tit">Website url <span class="required">*</span></div>
      <v-text-field
        v-model="store.websiteUrlLeeds"
        placeholder="Enter website URL"
        variant="outlined"
        density="comfortable"
        hide-details
        class="flat-select"
        :class="{ 'has-error': submitted && !store.websiteUrlLeeds }"
      />
    </v-col>

    <CreateLeedForm v-if="opd" v-model:dialog="opd" />
  </v-row>
</template>

<script>
import { useSuperAddStore } from "@/store/superAddStore";
import LeadsSearch from "@/components/SuperApp/LeadsSearch.vue";
import CreateLeedForm from "./Awareness/StepTree/CreateLeedForm.vue";
export default {
  components: { LeadsSearch, CreateLeedForm },
  data() {
    return {
      store: useSuperAddStore(),
      submitted: false,
      errors: [],
      opd: false,
      ctaOptions: [
        { label: "Apply now", value: "APPLY_NOW" },
        { label: "Book Now", value: "BOOK_NOW" },
        { label: "Sign Up", value: "SIGN_UP" },
      ],
    };
  },

  methods: {
    validate() {
      this.submitted = true;
      const errors = [];

      if (
        !this.store.websiteUrlLeeds ||
        !this.validUrl(this.store.websiteUrlLeeds)
      ) {
        errors.push(" Website URL is required and must be valid");
      }

      if (!this.store.ad_call_to_action_type) {
        errors.push(" Call to action is required");
      }

      const formErrors = Array.isArray(this.$refs.leadsSearchRef?.validate?.())
        ? this.$refs.leadsSearchRef.validate()
        : [];

      this.errors = [...errors, ...formErrors];
      return this.errors;
    },
    validUrl(url) {
      const pattern = new RegExp(
        "^(https?:\\/\\/)?" + // http:// or https://
          "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain
          "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
          "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
          "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$",
        "i"
      );
      return !!pattern.test(url);
    },
    getData() {
      return {
        attachmentType: "Lead form",
        websiteUrl: this.store.websiteUrlLeeds,
        cta: this.store.ad_call_to_action_type,
        ...(this.$refs.leadsSearchRef?.getData?.() || {}),
      };
    },
  },
};
</script>

<style scoped>
.lead-form-btn {
  min-height: 3rem;
  border: 1px solid #e8e8e8;
  color: #4d4d4d;
  border-radius: 8px;
}

.bgs {
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  margin: 2rem 0;
}

.label {
  font-weight: 600;
  margin-bottom: 6px;
}

.required {
  color: red;
}

.input-box {
  border-radius: 6px;
  min-width: 250px;
  margin-right: 12px;
  min-height: 2rem;
}

.flat-select .v-field {
  background-color: transparent !important;
  border-radius: 6px;
}

.tit {
  min-width: 14rem;
}

.has-error input,
.has-error .v-field,
.has-error .v-input__control {
  border-color: red !important;
  color: red !important;
}
</style>
